import {
  Tipligheri,
  Maipith,
  Dwariknagar,
  MER_CR_Demarcation2025,
  SHIVGURI_CR_Demarcation2025,
  PS0000149,
  PS000060,
  PS0000107,
  PS0000139,
  PS0000132,
} from '../mock/dummyGeoJson';
import { FeatureCollection, Feature, Geometry } from 'geojson';

// Merge multiple FeatureCollections into one
const mergeCollections = (...collections: FeatureCollection<Geometry>[]): FeatureCollection<Geometry> => ({
  type: 'FeatureCollection',
  features: collections.flatMap(c => c.features as Feature<Geometry>[]),
});

// Sundarbans / Mangrove data
export const SundarbansGeoJSON = mergeCollections(Tipligheri, Maipith, Dwariknagar);

// Arunachal Pradesh / Elephant Link data
export const ArunachalGeoJSON = mergeCollections(MER_CR_Demarcation2025, SHIVGURI_CR_Demarcation2025);

// Jharkhand / Agroforest data
export const JharkhandGeoJSON = mergeCollections(PS0000149, PS000060, PS0000107, PS0000139, PS0000132);

export const getProjectGeoJSON = (projectName: string): FeatureCollection<Geometry> => {
  const name = projectName.toLowerCase();

  if (name.includes('elephant') || name.includes('arunachal') || name.includes('link')) {
    return ArunachalGeoJSON;
  }

  if (name.includes('agroforest') || name.includes('jharkhand') || name.includes('dumka')) {
    return JharkhandGeoJSON;
  }

  // Default: Sundarbans for Mangrove and anything else
  return SundarbansGeoJSON;
};

export const getProjectCoordinates = (projectName: string): [number, number] => {
  const name = projectName.toLowerCase();

  if (name.includes('elephant') || name.includes('arunachal') || name.includes('link')) {
    return [95.49, 27.83]; // Arunachal Pradesh (Miao region)
  }

  if (name.includes('agroforest') || name.includes('jharkhand') || name.includes('dumka')) {
    return [87.39, 24.19]; // Jharkhand (Dumka region)
  }

  return [88.89, 22.11]; // Sundarbans default
};
